export default {
  title: "Estadísticas de dispositivos",
  description: "Analítica de producto del kiosk desde PostHog (producción).",
  iframeTitle: "Panel de estadísticas de dispositivos de PostHog",
  rangeLabel: "Periodo",
  ranges: {
    last7Days: "Últimos 7 días",
    last30Days: "Últimos 30 días",
    last90Days: "Últimos 90 días",
    thisMonth: "Este mes",
    lastMonth: "Mes pasado",
  },
} as const;
